var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"TextScrollBox",staticClass:"t-s"},[_c('span',{ref:"TextScrollValue"},[(_vm.boxWidth<_vm.valWidth)?[_c('marquee',{attrs:{"scrollamount":"4"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])]:_vm._e(),_vm._v(" "+_vm._s(_vm.value)+" ")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }